import type { AgentPanelAdapter } from './types';
import { createContext, useContext } from 'react';

// Each agent-aware page wraps its render output in <AdapterContext.Provider>
// with the domain adapter built by its `useXxxAgentAdapter` hook. The global
// <AgentPanel> (mounted in app-layout.tsx) and any domain-registered result
// renderers consume this context — pages without a Provider get the `null`
// default and the panel falls back to its empty-state children.
export const AdapterContext = createContext<AgentPanelAdapter | null>(null);

export const useAgentPanelAdapter = (): AgentPanelAdapter | null =>
  useContext(AdapterContext);
